function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 25.6,
  height: 32,
  rx: 2,
  fill: "#DDEDFC"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 3.83984,
  y: 6.4,
  width: 15.36,
  height: 2.56,
  rx: 1.28,
  fill: "#449CEE"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 3.83984,
  y: 11.52,
  width: 15.36,
  height: 2.56,
  rx: 1.28,
  fill: "#449CEE"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 3.83984,
  y: 16.64,
  width: 7.68,
  height: 2.56,
  rx: 1.28,
  fill: "#449CEE"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M5.93476 24.4609H7.25556C7.55342 24.4609 7.78047 24.4837 7.93672 24.5293C8.14668 24.5911 8.32653 24.701 8.47627 24.8588C8.62601 25.0167 8.73994 25.2104 8.81806 25.4399C8.89619 25.6678 8.93525 25.9493 8.93525 26.2846C8.93525 26.5792 8.89863 26.8331 8.82539 27.0463C8.73587 27.3068 8.6081 27.5175 8.44209 27.6787C8.31676 27.8007 8.14749 27.896 7.93427 27.9643C7.77477 28.0148 7.56155 28.04 7.29463 28.04H5.93476V24.4609ZM6.65742 25.0664V27.437H7.19697C7.39879 27.437 7.54446 27.4256 7.63398 27.4028C7.75117 27.3735 7.84801 27.3239 7.92451 27.2539C8.00263 27.1839 8.06611 27.0691 8.11494 26.9096C8.16377 26.7485 8.18818 26.5296 8.18818 26.2529C8.18818 25.9762 8.16377 25.7638 8.11494 25.6157C8.06611 25.4676 7.99775 25.352 7.90986 25.269C7.82197 25.186 7.71048 25.1298 7.57539 25.1005C7.47448 25.0778 7.27672 25.0664 6.98213 25.0664H6.65742ZM9.404 26.2724C9.404 25.9078 9.45853 25.6018 9.56758 25.3545C9.64896 25.1722 9.75963 25.0086 9.89961 24.8637C10.0412 24.7189 10.1958 24.6115 10.3635 24.5415C10.5865 24.4471 10.8436 24.3999 11.135 24.3999C11.6623 24.3999 12.0839 24.5634 12.3996 24.8906C12.717 25.2177 12.8757 25.6727 12.8757 26.2553C12.8757 26.8331 12.7186 27.2856 12.4045 27.6128C12.0904 27.9383 11.6704 28.101 11.1447 28.101C10.6125 28.101 10.1893 27.9391 9.87519 27.6152C9.56107 27.2897 9.404 26.8421 9.404 26.2724ZM10.1486 26.248C10.1486 26.6533 10.2422 26.9609 10.4294 27.1709C10.6166 27.3792 10.8542 27.4834 11.1423 27.4834C11.4304 27.4834 11.6664 27.38 11.8503 27.1733C12.0358 26.965 12.1286 26.6533 12.1286 26.2382C12.1286 25.8281 12.0383 25.5221 11.8576 25.3203C11.6786 25.1185 11.4401 25.0175 11.1423 25.0175C10.8444 25.0175 10.6044 25.1201 10.4221 25.3252C10.2398 25.5286 10.1486 25.8362 10.1486 26.248ZM15.7321 26.7241L16.4328 26.9463C16.3254 27.3369 16.1464 27.6274 15.8957 27.8178C15.6467 28.0066 15.3301 28.101 14.946 28.101C14.4707 28.101 14.0801 27.9391 13.7741 27.6152C13.4681 27.2897 13.3151 26.8453 13.3151 26.2822C13.3151 25.6865 13.4689 25.2242 13.7766 24.8955C14.0842 24.5651 14.4886 24.3999 14.9899 24.3999C15.4278 24.3999 15.7834 24.5293 16.0568 24.788C16.2196 24.941 16.3417 25.1608 16.423 25.4472L15.7077 25.6181C15.6654 25.4326 15.5767 25.2861 15.4416 25.1787C15.3081 25.0713 15.1454 25.0175 14.9533 25.0175C14.688 25.0175 14.4724 25.1128 14.3063 25.3032C14.142 25.4936 14.0598 25.802 14.0598 26.2285C14.0598 26.681 14.1411 27.0032 14.3039 27.1953C14.4667 27.3873 14.6783 27.4834 14.9387 27.4834C15.1307 27.4834 15.2959 27.4223 15.4343 27.3003C15.5726 27.1782 15.6719 26.9861 15.7321 26.7241ZM16.6916 28.04L17.9147 26.1723L16.8063 24.4609H17.6511L18.3688 25.6108L19.072 24.4609H19.9094L18.7961 26.1992L20.0192 28.04H19.1477L18.3542 26.8022L17.5583 28.04H16.6916Z",
  fill: "#439CEE"
});

function SvgFormatAppWordTinyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatAppWordTinyIcon);
export default __webpack_public_path__ + "static/media/format-app-word-tiny-icon.6b7e2169.svg";
export { ForwardRef as ReactComponent };